import React from "react";
import { Link } from "react-router-dom";

interface BrandMarkProps {
  dark?: boolean;
  compact?: boolean;
}

const BrandMark: React.FC<BrandMarkProps> = ({ dark = false, compact = false }) => (
  <Link
    to="/"
    className={`clearith-brand ${dark ? "is-dark" : ""} ${
      compact ? "is-compact" : ""
    }`}
    aria-label="CLEARITH — Accueil"
  >
    <img
        src="/logo-clearith.png"
        alt=""
        aria-hidden="true"
        className="clearith-brand__mark"
    />
    <span className="clearith-brand__text">
      CLEARITH
      {!compact && <small>FORMATION PROFESSIONNELLE</small>}
    </span>
  </Link>
);

export default BrandMark;
